import { Box, Button } from "@mui/material";
import { useEffect } from "react";

import Loading from "@/components/Loading/Index.tsx";
import { removeAllItemsFromStorage } from "@/hooks/UseTusHooks/Generics.tsx";
import { useTusUpload } from "@/hooks/UseTusHooks/useTusUpload";
import TusHooksDropZone from "./TusHooksDropZone";

export default function TusHooks({
  setUploadContent,
  feedId,
  autoClick,
}: {
  setUploadContent?: ({ itemId, contentId, name }: { contentId: string; itemId: string; name?: string }) => void;
  feedId?: string;
  autoClick?: boolean;
}) {
  const { startParsed, uploading, uploaded, error, reset } = useTusUpload({ feedId, onUploaded: setUploadContent });

  useEffect(() => {
    removeAllItemsFromStorage("tus::tus");
  }, []);

  const borderColor = uploaded ? "green" : error ? "red" : "grey";

  return (
    <Box sx={{ width: "100%" }}>
      {!error && !uploading && !uploaded ? (
        <TusHooksDropZone
          sx={{
            position: "relative",
            maxHeight: "390px",
            overflowY: "auto",
          }}
          autoClick={autoClick}
          setUploadData={(data) => data && startParsed(data)}
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            border: `dashed 2px ${borderColor}`,
            alignItems: "center",
            justifyContent: "center",
            p: 2,
            borderRadius: "1rem",
            gap: 2,
            minHeight: "120px",
          }}
        >
          {uploaded && <Box>File Uploaded</Box>}
          {uploading && !error && !uploaded && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <Box>Uploading</Box>
              <Loading variant="white" size="large" baseSize={6} />
            </Box>
          )}
          {error && !uploaded && (
            <Box>
              <Box sx={{ mb: 1 }}>There was an error uploading</Box>
              <Button onClick={reset}>Try Again</Button>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}
